export const TrimixFeaturedMedData = [
  {
    image: "/images/trimix/trimix-1.png",
    title: "Sildenafil",
    description: "Sildenafil is the active ingredient in Viagra®, designed to help you achieve and maintain an erection by increasing blood flow to the penis. It typically works within 30–60 minutes and lasts up to 4–6 hours.", 
  },
  {
    image: "/images/trimix/bimix-1.png",
    title: "Tadalafil",
    description: "Known as the active ingredient in Cialis®, Tadalafil provides longer-lasting results, with effects lasting up to 36 hours. It offers flexibility, allowing you to enjoy spontaneous moments without planning around your medication.", 
  },
  {
    image: "/images/trimix/quadmix-1.png",
    title: "Oxytocin",
    description: "Oxytocin, sometimes referred to as the \"love hormone\", enhances emotional connection and intimacy. It is used in specific cases to improve sexual satisfaction and bonding between partners.", 
  },
];